// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 1.79834L10 4.46501V10.8197L22 8.81973V22.0002H17V18.0002H13V22.0002H2V4.46501L6 1.79834Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-museum-2-filled')
export default class Museum2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'museum-2-filled',
    }
  }
}
